<template>
    <div class="row">
        <div class="col-12">
            <b-button
                @click="$modal.show(name)"
            >
                {{ button_title }}
            </b-button>
            <ModalComponent
                :name="name"
                :title="title"
                v-on:close="() => cerrar()"
            >  
                <slot></slot>
            </ModalComponent>
        </div>
    </div>    
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            name: {
                required: true,
                type: String
            },
            title: {
                required: true,
                type: String
            },
            button_title: {
                required: true,
                type: String
            }
        },
        methods: {
            cerrar() {
                this.$modal.hide(this.name);
                this.$emit('cerrar');
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
